<form>
    <input 
        type="email" 
        class="form-control form-control-auth m-auto py-3"
        maxlength="30"
        placeholder="{{'inputs.emailAddress' | translate }}">
        <br>
        <span class="fs-alert-vivi font-primary">
            <!-- Validation -->
        </span>

    <!-- INFO FOOT-->
    <div class="row justify-content-center mt-3">
        
        <!-- TXT 1 -->
        <!-- <div class="col-10">
            <p class="text-center font-primary">{{'signup.footer1' | translate }}<a routerLink="/auth/resend-code" class="font-primary">{{'signup.resend' | translate }}</a></p>
        </div> -->

        <!-- TXT 2 -->
        <!-- <div class="col-10">
        <p class="text-center font-primary"> {{'signup.footer2' | translate }} <a routerLink="/auth/property-search" class="font-primary">{{'signup.property' | translate }}</a></p>
        </div> -->

    </div>

    <!-- BUTTONS -->
    <div class="text-center mb-4">
        <button
            type="submit"
            class="btn-primary-gbl me-2"
            routerLink="/auth/step-2">
            {{ 'confirm_client.buttons.next' | translate | uppercase }}
        </button>
        <button
            type="button"
            class="btn-secondary-gbl ms-2"
            routerLink="/auth/login">
            {{ 'user.back' | translate | uppercase }}
        </button>
    </div>
    
</form>  